import { render } from "./ModalChat.vue?vue&type=template&id=a49e7572&scoped=true&ts=true"
import script from "./ModalChat.vue?vue&type=script&lang=ts"
export * from "./ModalChat.vue?vue&type=script&lang=ts"

import "./ModalChat.vue?vue&type=style&index=0&id=a49e7572&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a49e7572"]])

export default __exports__